/* eslint-disable no-restricted-globals */
// @ts-nocheck
import React, {useState, useEffect, useRef, useMemo} from "react";
import {Controller, useForm} from "react-hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {PatternFormat} from "react-number-format";
import {useClickOutside} from "hooks";
import {CloseButtonModal} from "components/CloseButton";
import {useStores} from "hooks/useStores";
import {useNavigate} from 'react-router';
import {ROUTES_PATHS} from 'const';
import {INVALIDATION_TIP, REGEX} from "../../const/validation";

import styles from "./styles/lkChangeEmail.module.scss";
import {TextInput} from "../TextInput";
import {useSearchParams} from "react-router-dom";

const inputStyle = {
  width: "200px",
  textAlign: "center",
  height: "46px",
  background: "#ffffff",
  border: "2px solid #dddde3",
  borderRadius: "6px",

  fontFamily: "Gilroy",
  fontStyle: "normal",
  fontWeight: "bold",
  fontSize: "32px",
  lineHeight: "160%",
  padding: "0 12px",
};

const firstStepSchema = yup.object().shape({
  email: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(
      REGEX.VALID_EMAIL,
      INVALIDATION_TIP.INCORRECT_EMAIL,
    )
});

const secondStepSchema = yup.object().shape({
  email: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(
      REGEX.VALID_EMAIL,
      INVALIDATION_TIP.INCORRECT_EMAIL,
    ),
  code: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{6}/, INVALIDATION_TIP.INCORRECT_CODE_LENGTH),
});

const CREAT_EMAIL_STEPS = {
  GET_CODE: 1,
  CHECK_CODE: 2
};

export const handleChangeMaxLength = (e, maxLength) => {
  e.target.value = e.target.value.slice(0, maxLength);
};


export default function LkChangeEmailNew(props) {
  const [emailChanged, setEmailChanged] = useState(false);
  const [confirmEmail, setConfirmEmail] = useState(false);
  const [code, setCode] = useState("");
  const [response, setResponse] = useState({});
  const [disabled, setDisabled] = useState(true);

  const [step, setStep] = useState(1);

  const {api, userStore} = useStores();

  const containerRef = useClickOutside(() => {
    closeChangeEmail();
  })

  const formSchema = useMemo(
    () => (step === 1 ? firstStepSchema : secondStepSchema),
    [step],
  );

  const {
    register,
    handleSubmit,
    setValue,
    formState: {errors, isValid},
    reset,
    setFocus,
    setError,
    clearErrors,
    control
  } = useForm({
    mode: "all",
    resolver: yupResolver(formSchema),
  });

  const getCode = (data) => {
    const reqObj = {...data, email: data.email};

    reset({code: ''}, {keepValues: true});
    api.user.postChangeMailConfirm(reqObj)
      .then((response) => {
        setConfirmEmail(true);
        handleGetCode();
      })
      .catch((error) => {
        setError('email', {
          message: error.response.data.error,
        });
      });
  }

  const onSubmit = (data) => {
    switch (step) {
      case CREAT_EMAIL_STEPS.GET_CODE:
        getCode(data);
        break;
      case CREAT_EMAIL_STEPS.CHECK_CODE:
        api.user.postChangeMailConfirm({
          email: data.email,
          confirm_code: data.code,
        })
          .then((response) => {
            if (response.code_valid === false) {
              setError('code', {
                message: INVALIDATION_TIP.INCORRECT_CODE_SMS,
              });
              return;
            }
            setResponse(response);
            setEmailChanged(false);
            userStore.getUser();
            goToLk();
          })
          .catch((error) => {
            setError('code', {
              message: INVALIDATION_TIP.INCORRECT_CODE_SMS,
            });
          });
        break;
      default:
        break;
    }
  };

  const handleGetCode = () => {
    setStep(2);
    clearErrors();
  };

  const closeChangeEmail = () => {
    document.querySelector("#changeEmailPopup").style.display = "none";
    reset({
      email: "",
    });
    setStep(1);
  };

  const goToLk = () => {
    closeChangeEmail();
    setEmailChanged(false);
    setStep(1)
  };

  useEffect(() => {
    if (code.split("").length === 6) {
      setDisabled(false);
    }
  }, [code]);

  useEffect(() => {
    setFocus("email");
    setValue("oldEmail", props.email);
  }, [props.modal]);

  return (
    <div className={styles.change_email} id='changeEmailPopup'>
      <div className={styles.change_email__container} ref={containerRef}>
        <CloseButtonModal handleClose={closeChangeEmail}/>

          <div className={styles.change_email__container_main} id='containerMain'>
            <h2 className={styles.change_email__title}>Изменение email</h2>
            <form className={styles.change_email_form} onSubmit={handleSubmit(onSubmit)}>
              <div className={styles.change_email__form_items}>
                <lable className={styles.change_email__lable} htmlFor='oldEmail'>
                  Старый email<span className='lk-personal-form__span'>*</span>
                </lable>
                <input className={styles.change_email__input_mail}
                       autoFocus
                       {...register("oldEmail")}
                       id='oldEmail'
                       name='oldEmail'
                       type='oldEmail'
                       disabled
                />
              </div>

              <div className={styles.change_email__form_items}>
                <lable className={styles.change_email__lable} htmlFor='email'>
                  Новый email<span className='lk-personal-form__span'>*</span>
                </lable>
                <input
                  autoFocus
                  {...register("email")}
                  id='email'
                  name='email'
                  type='email'
                  disabled={step !== 1}
                  className={styles.change_email__input_mail}
                />
                {errors.email && (
                  <p className={styles.change_email__err_mail}>{errors.email?.message}</p>
                )}

              </div>

              {step === 1 && (
                <button
                  className={styles.change_email_button}
                  text="Получить код на Email"
                  type="submit"
                  disabled={!isValid}
                >Получить код на Email</button>
              )}

               {step === 2 &&  (
                <div className={styles.change_email__form_items}>
                  <lable className={styles.change_email__lable} htmlFor='code'>
                    Код из e-mail
                  </lable>
                  <Controller
                    render={({field: {onChange, value}}) => (
                      <TextInput
                        className={styles.change_email__input_pattern}
                        type="number"
                        controls={false}
                        onChange={(event) => {
                          handleChangeMaxLength(event, 6)
                          onChange(event)
                        }}
                        step={1}
                      />
                    )}
                    name="code"
                    control={control}
                    step={1}
                  />
                  {errors.code && (<span className={styles.change_email__err_mail}>
                  {errors.code?.message}
                </span>
                  )}
                  <button
                    text="Сохранить"
                    type="submit"
                    disabled={!isValid}
                    className={styles.change_email_button}>Сохранить изменения
                  </button>
                </div>
              )}

            </form>
          </div>

      </div>
    </div>
  );
}
